import * as Util from '../util/utilities'

export default {
    init() {
        const scrollcontrol = new ScrollMagic.Controller()
        const windowHalfX = window.innerHeight / 2

        if ($('.split-cta').length) {
            this.split(scrollcontrol, windowHalfX)
        } else if ($('[data-cta-parallax]').length) {
            this.single(scrollcontrol, windowHalfX)
        }
    },
    split(scrollcontrol, windowHalfX) {
        $('.split-cta').each(function () {
            const topAsset = $(this).find('[data-cta-asset-t]')
            const bottomAsset = $(this).find('[data-cta-asset-b]')

            if ($(this).find('[data-cta-content]').length) {
                const bottomAsset = $(this).find('[data-cta-content]')
            }

            Util.addAnimations(
                [
                    TweenMax.fromTo(
                        topAsset,
                        2,
                        {
                            y: '-12%',
                        },
                        {
                            y: '16%',
                            ease: Linear.easeNone,
                        },
                    ),
                    TweenMax.fromTo(
                        bottomAsset,
                        2,
                        {
                            y: '-12%',
                        },
                        {
                            y: '16%',
                            ease: Linear.easeNone,
                        },
                    ),
                ],
                this,
                '',
                -windowHalfX,
                '200%',
                scrollcontrol,
            )
        })
    },
    single(scrollcontrol, windowHalfX) {
        $('[data-cta-parallax]').each(function () {
            const asset = $(this).find('[data-cta-asset]')

            Util.addAnimations(
                [
                    TweenMax.fromTo(
                        asset,
                        2,
                        {
                            y: '-24%',
                        },
                        {
                            y: '24%',
                            ease: Linear.easeNone,
                        },
                    ),
                ],
                this,
                '',
                -windowHalfX,
                '200%',
                scrollcontrol,
            )
        })
    },
}
